import BuildingPage from 'pages/BuildingPage';

const AdminContacts = (): JSX.Element => <BuildingPage />;

export default AdminContacts;
